import { render, staticRenderFns } from "./img-editor.vue?vue&type=template&id=21d86d10&scoped=true&"
import script from "./img-editor.vue?vue&type=script&lang=js&"
export * from "./img-editor.vue?vue&type=script&lang=js&"
import style0 from "./img-editor.vue?vue&type=style&index=0&id=21d86d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d86d10",
  null
  
)

export default component.exports